import axios from 'axios';

const api = axios.create({
  // baseURL: "http://192.168.29.29:5000/api/influencers"
  // baseURL: "https://admin.roamjssln.com/api/influencers"
  baseURL: "https://development.roamjssln.com/api/influencers"
});

export default api;